/** @format */

import { all, call } from "redux-saga/effects";
import userSaga from "./userSaga";

function* rootSaga() {
  yield all([call(userSaga)]);
}
export default rootSaga;
